<style>
	.bg777 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar9{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar9 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar9 span.pos{ padding:0 1vw;}
.tabbar9 span.floder{ color:#666;}
 
.tabbar9 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
.result_list{width:84vw;margin-left:7vw;margin-top:7vw;min-height:10vw;border:#ddd solid 1px;border-radius:.5vw;box-sizing:border-box;}
.lists_top{width:100%;height:8vw;border-bottom:#ddd solid 1px;}
.lists_top_left{width:49vw;float:left;height:100%;position:relative;box-sizing:border-box;}
.lists_top_left img{display:block;position:absolute;left:2vw;top:2vw;width:3vw;}
.lists_top_left span{display:block;position:absolute;}
.lists_top_left span.r1{top:2.2vw;left:5vw;font-size:1.3vw;color:#0F7A3E;}
.lists_top_left span.r2{top:4.2vw;left:5vw;font-size:1vw;color:#999;border:#ddd solid 1px;line-height:2vw;padding:0 .5vw;border-radius:.5vw;}
.lists_top_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.lists_top_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1vw;
 color:#333;}
 
.lists_top_right{width:14vw;height:100%; float:right;box-sizing:border-box;}
.lists_top_right span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:12vw;padding:0 1vw;font-size:1vw;
 color:#333;}
.lists_top_right span.mn2{color:#0F7A3E;}
.lists_top_right span.mn3{color:#f00;}
.lists_top_fresh{width:10vw;height:100%; float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.lists_top_fresh img{display:block;margin:0 auto;width:2.5vw;margin-top:2vw;}
.lists_top_fresh span{display:block;width:100%;text-align:center;line-height:3vw;color:#3465ff;font-size:1vw;}


.table_title{width:100%;height:3vw;background:#fff1f1;}
.table_title span{display:block;float:left;font-size:1vw;line-height:3vw;text-align:left;}
.table_title span.t1{width:15%;padding-left:5%;}
.table_title span.t2{width:10%;}
.table_title span.t3{width:20%;}
.table_title span.t4{width:20%;}
.table_title span.t5{width:20%;padding-right:5%;}
.result_list ul{width:100%;height:20vw;overflow-y:scroll;}
.result_list ul li{width:100%;height:3vw;}
.result_list ul li span{display:block;float:left;font-size:1vw;line-height:3vw;text-align:left;}
.result_list ul li span.t1{width:15%;padding-left:5%;}
.result_list ul li span.t2{width:10%;}
.result_list ul li span.t3{width:20%;}
.result_list ul li span.t4{width:20%;}
.result_list ul li span.t5{width:20%;padding-right:5%;}

.submits2{width:12vw;height:4vw;background:#fff;border:#ddd solid 1px;margin-top:5vw;border-radius:.5vw;}
.submits2 span{display:block;float:left;width:6vw;text-align:center;color:#999;font-size:1.4vw;line-height:4vw;}
.submits2 img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;margin-left:1.5vw;}

</style>
 
<template>
	<div class="bg777">
		     
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img src="../../assets/images/home_icon.png">
			<div class="tabbar9">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送短信通知</span>
			   <span class="rights"></span>
			   <span class="floder">选择短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">导入数据表</span>
			   <span class="rights"></span>
			   <span class="floder">选择数据表关键信息</span>
			</div>
		 </div>
		 <div class="result_list">
		    <div class="lists_top">
			   <div class="lists_top_left">
			       <img src="../../assets/images/excel.png">
				   <span class="r1">清华大学统招本科录取名单.xlsx</span>
				   <span class="r2">2021年-统招-本科批-普通类-四川省-录取名单</span>
			   </div>
			   <div class="lists_top_fresh">
			        <img src="../../assets/images/fresh.svg">
				    <span>刷新数据</span>
			   </div>
			   <div class="lists_top_right">
			      <span class="mn1">7077</span>
				  <span class="mn2">7000</span>
				  <span class="mn3" style="border-bottom:0;">7</span>
			   </div>
			   <div class="lists_top_middle">
			      <span class="m1">总数据条数</span>
				  <span class="m2">导入成功</span>
				  <span class="m3" style="border-bottom:0;">导入失败</span>
			   </div>
			</div>
			<div class="table_title">
			    <span  class="t1">姓名</span>
				<span  class="t2">性别</span>
				<span  class="t3">联系电话</span>
				<span  class="t4">考生号</span>
				<span  class="t5">身份证号</span>
			</div>
			<ul>
			   <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			  <li> <span  class="t1">年高三</span>
					<span  class="t2">难</span>
					<span  class="t3">18148481148</span>
					<span  class="t4">86547245232</span>
					<span  class="t5">510111111111111111</span>
			  </li>
			</ul>
		 </div> 
		   <div class="submits2">
		      <img src="../../assets/images/pre2.svg">
		     <span>上一步</span>
			 
		 </div> 
		 

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				 
			}
		},
		mounted() {
		    let self=this;
		    
		 
			
		},
		methods: {
		     
		     
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/view_failed.vue